import { IconButton, Modal, Stack, Text, TooltipHost } from '@fluentui/react';
import { useStyles } from './index.styles';
import React, { useMemo, useState } from 'react';
import { CloseButton } from 'common/components/Buttons';
import { Hierarchy } from './Hierarchy';

const HEADER_TITLE = 'Preview Hierarchy';

export interface PreHierarchyModalProps {
  entityId: string | undefined;
}
export const PreHierarchyModal: React.FC<PreHierarchyModalProps> = ({
  entityId,
}) => {
  const [visible, setVisible] = useState(false);
  const styles = useStyles();

  const HierarchyComponent = () => {
    if (entityId)
      return (
        <Stack className={styles.hierarchyContainer}>
          <Hierarchy entityId={entityId} />
        </Stack>
      );
    else return null;
  };

  const MemoizedHierarchyComponent = useMemo(HierarchyComponent, [entityId]);
  if (entityId)
    return (
      <Stack>
        <TooltipHost content={'Preview Approval Hierarchy'}>
          <IconButton
            iconProps={{ iconName: 'Org' }}
            ariaLabel="Org"
            onClick={() => setVisible(true)}
          />
        </TooltipHost>

        {visible && (
          <Modal
            isOpen
            scrollableContentClassName={styles.noScrollContainer}
            containerClassName={styles.modalContainer}
          >
            <Stack className={styles.container}>
              <Stack
                className={styles.headerContainer}
                tokens={{ padding: 25 }}
              >
                <Stack
                  horizontalAlign="space-between"
                  horizontal
                  className={styles.alignItemsCenter}
                  tokens={{ childrenGap: 10 }}
                >
                  <Stack
                    className={styles.alignItemsCenter}
                    horizontal
                    tokens={{ childrenGap: 10 }}
                  >
                    <Text variant={'xLarge'}>{HEADER_TITLE}</Text>
                  </Stack>

                  <Stack>
                    <CloseButton onClick={() => setVisible(false)} />
                  </Stack>
                </Stack>
              </Stack>
              {MemoizedHierarchyComponent}
            </Stack>
          </Modal>
        )}
      </Stack>
    );
  else return null;
};
